export interface PmApprovalRequestDto {
  id: string;
  issueId: string;
  issueKey: string;
  issueSummary: string;
  projectId: string;
  projectName: string;
  transitionId?: string;
  transitionName?: string;
  automationRuleId?: string;
  approverEmployeeId: string;
  approverName: string;
  requestedByEmployeeId?: string;
  requestedByName?: string;
  title: string;
  message?: string;
  status: number;
  statusLabel: string;
  decidedAt?: string;
  decisionComment?: string;
  createdAt: string;
}

export interface DecidePmApprovalRequest {
  approve: boolean;
  comment?: string;
  reExecuteTransition?: boolean;
}

export const PM_APPROVAL_STATUS_OPTIONS = [
  { value: 0, label: 'Pending' },
  { value: 1, label: 'Approved' },
  { value: 2, label: 'Rejected' },
  { value: 3, label: 'Cancelled' }
];
